<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL">新增疫苗驱虫</div>
        <div class="titleR">
          <el-button type="warning" plain size="small" @click="back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content">
        <div class="L">
          <div class="item">
            <div class="label">设置体重</div>
            <div class="value">
              <el-input
                style="width: 210px"
                v-model="newestWeight"
                @input="changeNewestWeight"
                :rows="5"
                size="small"
                placeholder="请录入宠物最新体重"
              >
                <template slot="append">kg</template>
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="label">销售人员</div>
            <div class="value">
              <el-select
                style="width: 210px"
                v-model="saleManIdList"
                @change="changeSaleManIdList"
                multiple
                filterable
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in staffList"
                  :key="item._id"
                  :label="item.basic_info.nick_name"
                  :value="item._id + ',' + item.basic_info.nick_name"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="label">疫苗驱虫</div>
            <div class="value">
              <el-radio-group
                style="width: 210px; margin: 7px 0"
                v-model="type"
                @change="changeType"
              >
                <el-radio style="margin-right: 25px" :label="'YM'"
                  >疫苗</el-radio
                >
                <el-radio style="margin-right: 25px" :label="'QC'"
                  >驱虫</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="item">
            <div class="label">套餐类型</div>
            <div class="value">
              <el-radio-group
                style="width: 230px; margin: 7px 0"
                v-if="type === 'QC'"
                v-model="buyWay2"
                @change="changeBuyWay"
              >
                <span v-for="(item, index) in QCGroupTypeList" :key="index">
                  <el-radio
                    v-if="item.value === '0'"
                    style="margin-right: 20px"
                    :label="'0'"
                    >满赠</el-radio
                  >
                  <el-radio
                    v-if="item.value === '1'"
                    style="margin-right: 20px"
                    :label="'1'"
                    >折扣</el-radio
                  >
                  <el-radio
                    v-if="item.value === '2'"
                    style="margin-right: 20px"
                    :label="'2'"
                    >自定义</el-radio
                  >
                </span>
              </el-radio-group>
              <el-radio-group
                style="width: 230px; margin: 7px 0"
                v-else
                v-model="buyWay1"
                @change="changeBuyWay"
              >
                <span v-for="(item, index) in YMGroupTypeList" :key="index">
                  <el-radio
                    v-if="item.value === '0'"
                    style="margin-right: 20px"
                    :label="'0'"
                    >满赠</el-radio
                  >
                  <el-radio
                    v-if="item.value === '1'"
                    style="margin-right: 20px"
                    :label="'1'"
                    >折扣</el-radio
                  >
                  <el-radio
                    v-if="item.value === '2'"
                    style="margin-right: 20px"
                    :label="'2'"
                    >自定义</el-radio
                  >
                </span>
              </el-radio-group>
            </div>
          </div>
          <div class="item">
            <div class="label">项目名称</div>
            <div class="value">
              <el-radio-group
                style="width: 210px; margin-top: 3px"
                v-if="type === 'YM' && YMList.length"
                v-model="serviceId"
                @change="changeServiceId"
              >
                <el-radio
                  :disabled="!newestWeight"
                  style="margin-right: 25px; display: block; line-height: 22px"
                  :label="item.groupId"
                  v-for="(item, index) in YMList"
                  :key="index"
                  >{{ item.title }}</el-radio
                >
              </el-radio-group>
              <el-radio-group
                style="width: 210px; margin-top: 3px"
                v-if="type === 'QC' && QCList.length"
                v-model="serviceId"
                @change="changeServiceId"
              >
                <el-radio
                  :disabled="!newestWeight"
                  style="margin-right: 25px; display: block; line-height: 22px"
                  :label="item.groupId"
                  v-for="(item, index) in QCList"
                  :key="index"
                  >{{ item.title }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <!-- 疫苗 疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗疫苗                   -->
          <div v-if="type === 'YM'">
            <div class="item">
              <div class="label">
                <span
                  style="
                    color: #f56c6c;
                    font-size: 16px;
                    margin-right: 3px;
                    vertical-align: sub;
                  "
                  >*</span
                >
                三针疫苗
              </div>
              <div class="value">
                <el-select
                  style="width: 210px"
                  v-model="vaccine_plan"
                  @change="changeVaccine_plan"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in servicePackage.vaccine_plan
                      ? servicePackage.vaccine_plan.use_items
                      : []"
                    :key="item._id"
                    :label="item.goods_name"
                    :value="item.goods_id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="item">
              <div class="label">
                <span
                  style="
                    color: #f56c6c;
                    font-size: 16px;
                    margin-right: 3px;
                    vertical-align: sub;
                  "
                  >*</span
                >
                狂犬疫苗
              </div>
              <div class="value">
                <el-select
                  style="width: 210px"
                  v-model="rabies_vaccine_plan"
                  @change="changeRabies_vaccine_plan"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in servicePackage.rabies_vaccine_plan
                      ? servicePackage.rabies_vaccine_plan.use_items
                      : []"
                    :key="item._id"
                    :label="item.goods_name"
                    :value="item.goods_id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="item">
              <div class="label">附加项</div>
              <div class="value">
                <el-radio-group
                  v-model="free1"
                  @change="changeFree1"
                  :disabled="
                    !!servicePackage.additional_enhance_needle.charge_status
                  "
                  style="
                    width: 135px;
                    text-align: center;
                    display: block;
                    margin: 7px 0;
                  "
                >
                  <el-radio style="margin-right: 10px" :label="false"
                    >收费</el-radio
                  >
                  <el-radio style="margin-right: 0px" :label="true"
                    >免费</el-radio
                  >
                </el-radio-group>
                <el-select
                  v-model="additional_enhance_needle"
                  @change="changeAdditional_enhance_needle"
                  multiple
                  placeholder="请选择"
                  size="small"
                  style="width: 210px; display: block"
                  key="additional_enhance_needle"
                >
                  <el-option
                    v-for="item in servicePackage.additional_enhance_needle
                      ? servicePackage.additional_enhance_needle.use_items
                      : []"
                    :key="item._id"
                    :label="item.goods_name"
                    :value="item.goods_id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="item">
              <div class="label">检测项</div>
              <div class="value">
                <el-radio-group
                  v-model="free2"
                  @change="changeFree2"
                  :disabled="
                    !!servicePackage.additional_medical_service_plan
                      .charge_status
                  "
                  style="
                    width: 135px;
                    text-align: center;
                    display: block;
                    margin: 7px 0;
                  "
                >
                  <el-radio style="margin-right: 10px" :label="false"
                    >收费</el-radio
                  >
                  <el-radio style="margin-right: 0px" :label="true"
                    >免费</el-radio
                  >
                </el-radio-group>
                <el-select
                  v-model="additional_medical_service_plan"
                  @change="changeAdditional_medical_service_plan"
                  multiple
                  placeholder="请选择"
                  size="small"
                  style="width: 210px; display: block"
                  key="additional_medical_service_plan"
                >
                  <el-option
                    v-for="item in servicePackage.additional_medical_service_plan
                      ? servicePackage.additional_medical_service_plan.use_items
                      : []"
                    :key="item._id"
                    :label="item.goods_name"
                    :value="item.goods_id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="item" v-if="buyWay1 === '1'">
              <div class="label">折扣</div>
              <el-input
                :value="$public.cheng(servicePackage.discount_rate, 100)"
                disabled
                size="small"
                style="width: 210px"
              >
                <template slot="append">折</template>
              </el-input>
            </div>
            <div class="item" v-if="buyWay1 === '2'">
              <div class="label">自定义价格</div>
              <div class="value">
                <el-input
                  v-model="YMCustomPrice"
                  @input="changeYMCustomPrice"
                  size="small"
                  style="width: 210px; margin-bottom: 5px"
                >
                  <template slot="append">元</template>
                </el-input>
                <span style="display: block; font-size: 14px; color: #ff2a3a"
                  >自定义价格区间 {{ servicePackage.min_price }} -
                  {{ servicePackage.max_price }}元</span
                >
              </div>
            </div>
          </div>
          <!-- 驱虫 驱虫驱虫驱虫驱虫驱虫驱虫驱虫驱虫驱虫                   -->
          <div v-if="type === 'QC' && QCPlanItem">
            <div class="item">
              <div class="label" v-if="buyWay2 === '0'">满赠方式</div>
              <div class="value">
                <el-radio-group
                  v-if="buyWay2 === '0'"
                  v-model="zengTime"
                  @change="changeZengTime"
                  style="width: 210px; margin-top: 7px"
                >
                  <el-radio
                    style="margin-bottom: 5px"
                    :label="item.times"
                    v-for="(item, index) in servicePackage.buy_options"
                    :key="index"
                  >
                    买{{ item.times }}次赠{{ item.give_times }}次
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="item">
              <div class="label">
                <span v-if="must_use2==1" style="color: #f56c6c; font-size: 16px; margin-right: 3px"
              >*</span
            >
                设置体外驱虫项
              </div>
              <div class="value">
                <el-select
                  v-model="outside"
                  @change="changeOutside"
                  placeholder="请选择"
                  size="small"
                  style="width: 210px"
                >
                  <el-option
                    v-for="item in QCPlanItem.outside_body_plan
                      .plan_detail_items"
                    :key="item.goods_id"
                    :label="item.goods_name"
                    :value="item.goods_id"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-if="buyWay2 === '1' || buyWay2 === '2'"
                  v-model="QCTime2"
                  @input="changeQCTime2"
                  size="small"
                  style="width: 210px; margin-top: 7px"
                >
                  <template slot="append">次</template>
                </el-input>
              </div>
            </div>
            <div class="item">
              <div class="label"><span v-if="must_use1==1" style="color: #f56c6c; font-size: 16px; margin-right: 3px"
              >*</span
            >设置赠送体内驱虫项</div>
              <div class="value">
                <el-select
                  v-model="inside"
                  @change="changeInside"
                  placeholder="请选择"
                  size="small"
                  style="width: 210px"
                >
                  <el-option
                    v-for="item in QCPlanItem.inside_body_plan
                      .plan_detail_items"
                    :key="item.goods_id"
                    :label="item.goods_name"
                    :value="item.goods_id"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-if="buyWay2 === '1' || buyWay2 === '2'"
                  v-model="QCTime1"
                  @input="changeQCTime1"
                  size="small"
                  style="width: 210px; margin-top: 7px"
                >
                  <template slot="append">次</template>
                </el-input>
                <div
                  v-if="buyWay2 === '1'"
                  style="font-size: 14px; line-height: 20px; padding-left: 10px"
                >
                  <div
                    v-for="(item, index) in servicePackage.buy_options"
                    :key="index"
                  >
                    {{ item.discount_rate }}折 {{ item.times }}次
                  </div>
                </div>
              </div>
            </div>
            <div class="item" v-if="buyWay2 === '2'">
              <div class="label">最低折扣</div>
              <div class="value">
                <el-input
                  v-model="QCDiscount"
                  @input="changeQCDiscount"
                  size="small"
                  style="width: 210px"
                >
                  <template slot="append">折</template>
                </el-input>
                <span
                  style="
                    display: block;
                    font-size: 14px;
                    color: #ff2a3a;
                    margin-top: 7px;
                  "
                  >最低改价折扣为{{
                    $public.cheng(servicePackage.discount_rate, 100)
                  }}折</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="R">
          <div style="padding: 30px 10px">
            <el-table
              :stripe="true"
              :data="detail.list"
              style="width: 100%"
              :ref="'table'"
              default-expand-all
            >
              <el-table-column type="expand" width="50">
                <template slot-scope="scope">
                  <el-table
                    border
                    :data="scope.row.planGoods"
                    :ref="'table' + scope.$index"
                  >
                    <el-table-column label="名称" prop="goodsName" width="200">
                      <template slot-scope="props">
                        {{ props.row.goodsName }}
                      </template>
                    </el-table-column>
                    <el-table-column label="规格" prop="skuValue" width="150">
                    </el-table-column>
                    <el-table-column label="数量" prop="num" width="150">
                      <template slot-scope="props">
                        {{ props.row.num }}
                      </template>
                    </el-table-column>
                    <el-table-column label="单位" prop="unit" width="100">
                    </el-table-column>
                    <el-table-column label="单价" prop="originalPrice">
                    </el-table-column>
                    <el-table-column label="小计">
                      <template slot-scope="props">
                        {{ props.row.totalMoney }}
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column label="计划名称" width="150" prop="planName">
              </el-table-column>
              <el-table-column label="计划日期">
                <template slot-scope="scope">
                  <div>
                    {{ $public.FTime(scope.row.planDate, "YYYY-MM-DD") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="距离下一次计划" prop="intervalDays">
              </el-table-column>
              <el-table-column label="金额" prop="planMoney"> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="settlement">
      <div class="settlementL">
        <span>
          <span>总计：</span>
          <span>￥{{ totalMoney }}</span>
        </span>
        <span style="margin-left: 15px">
          <span>优惠金额：</span>
          <span>￥0</span>
        </span>
      </div>
      <div class="settlementR">
        <span>
          <span>应付金额：</span>
          <span style="margin-right: 30px">￥{{ totalMoney }}</span>
        </span>
        <el-button
          type="warning"
          size="small"
          plain
          @click="drawerRemark_state = true"
          >备注</el-button
        >
        <el-button
          type="warning"
          size="small"
          plain
          @click="
            direct = false;
            submitOrder();
          "
          >生成订单</el-button
        >
        <el-button
          type="warning"
          size="small"
          @click="
            direct = true;
            submitOrder();
          "
          >结算</el-button
        >
      </div>
    </div>
    <!-- 备注弹窗 -->
    <div v-show="drawerRemark_state">
      <drawerRemark
        :state="drawerRemark_state"
        :str="remark"
        @submit="submit_drawerRemark"
      ></drawerRemark>
    </div>
    <!-- 结算 -->
    <div v-if="dialogPay_state">
      <dialogQRCode
        :QRCode="codeUrl"
        :orderNum="curOrder._id"
        @submit="submit_dialog_pay"
      ></dialogQRCode>
    </div>
    <!-- 选择支付方式 医疗-->
    <div v-if="yiliao_state">
      <dialogYiLiao
        :orderNum="curOrder.no"
        :orderId="orderId"
        @submit="submityiLiao"
      ></dialogYiLiao>
    </div>
  </div>
</template>
<script>
import dialogYiLiao from "../../../../components/dialog_yiliao.vue";
import dialogQRCode from "../../../../components/dialogQRCode.vue";
import drawerRemark from "../../../../components/drawer/drawer_remark.vue";
export default {
  components: { dialogQRCode, drawerRemark, dialogYiLiao },
  data() {
    return {
      orderId: "",
      yiliao_state: false,
      // 宠物
      petList: [],
      // 最新体重
      newestWeight: "",
      // 销售人员
      saleManIdList: [],
      staffList: [],
      // 疫苗或驱虫
      type: "YM",
      buyWay1: "0",
      buyWay2: "0",
      // 套餐
      serviceId: "",
      servicePackage: {
        vaccine_plan: {},
        rabies_vaccine_plan: {},
        additional_enhance_needle: {},
        additional_medical_service_plan: {},
        discount_rate: 0,
        buy_options: [],
        plan_items: [],
        min_price: 0,
        max_price: 0,
      },
      YMList: [],
      QCList: [],
      // 疫苗
      vaccine_plan: "",
      rabies_vaccine_plan: "",
      additional_enhance_needle: "",
      additional_medical_service_plan: "",
      free1: true,
      free2: true,
      YMDiscount: "88",
      YMCustomPrice: "",
      // 驱虫
      QCPlanItem: null,
      inside: "",
      outside: "",
      zengTime: 3,
      QCTime1: 1,
      QCTime2: 1,
      QCDiscount: "88",
      // 疫苗驱虫详情
      detail: { list: [] },
      totalMoney: 0,
      YMGroupTypeList: [],
      QCGroupTypeList: [],
      // 备注
      drawerRemark_state: false,
      remark: "",
      // 结算
      dialogPay_state: false,
      codeUrl: "",
      curOrder: {},
      direct: false,
      YMQCDetail: {},
      must_use1:0,//否 1是 体内
      must_use2:0,//否 1是
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.yiliaoxin.userInfo;
    },
    curPetInfo() {
      let obj = this.$store.getters["yiliaoxin/curPetInfo"];
      return obj;
    },
    ymqcParams() {
      return this.$store.state.yiliaoxin.ymqcParams;
    },
  },
  watch: {
    curPetInfo(n) {
      this.serviceId = "";
      this.QCPlanItem = {
        _id: "",
        weight_model: {},
        inside_body_plan: {
          plan_name: "",
          must_use: 1,
          next_plan_days: 1,
          plan_detail_items: [],
        },
        outside_body_plan: {
          plan_name: "",
          must_use: 1,
          next_plan_days: 1,
          plan_detail_items: [],
        },
      };
      this.newestWeight = n.weight;
      if (this.type === "QC") {
        this.getQCList();
      } else {
        this.getYMList();
      }
    },
  },
  mounted() {
    this.newestWeight = this.curPetInfo.weight;
    this.getStaffList();
    this.getGroupTypeList();
    this.$store.state.yiliaoxin.userController.map((controller) => {
      if (controller.invitationType === 3 && controller.userId.length > 0) {
        this.saleManIdList = [controller.userId + "," + controller.userName];
      }
    });
  },
  methods: {
    // 关闭医疗支付弹框
    submityiLiao() {
      this.yiliao_state = false;
    },
    // 返回
    back() {
      this.ymqcParams.type = "list";
      this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
    },
    // 体重
    changeNewestWeight() {
      this.newestWeight = this.$public.replaceGoodsDosage(this.newestWeight);
      this.serviceId = "";
      if (this.type === "YM") {
        this.getYMList();
      } else {
        this.QCPlanItem = {
          _id: "",
          weight_model: {},
          inside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
          outside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
        };
        this.getQCList();
      }
    },
    // 类型
    changeType() {
      this.serviceId = "";
      if (this.type === "YM") {
        this.buyWay1 = this.YMGroupTypeList[0].value;
        this.getYMList();
      } else {
        this.buyWay2 = this.QCGroupTypeList[0].value;
        this.QCPlanItem = {
          _id: "",
          weight_model: {},
          inside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
          outside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
        };
        this.getQCList();
      }
    },
    // 类型
    changeBuyWay() {
      this.serviceId = "";
      if (this.type === "QC") {
        this.getQCList();
      } else {
        this.getYMList();
      }
    },
    // 改变服务
    changeServiceId() {
      if (this.type === "YM") {
        this.vaccine_plan = "";
        this.rabies_vaccine_plan = "";
        this.additional_enhance_needle = "";
        this.additional_medical_service_plan = "";
        this.YMDiscount = "88";
        this.servicePackage = this.$public.getMatchingItem(
          this.YMList,
          "groupId",
          this.serviceId
        );
        if (this.servicePackage.additional_enhance_needle.charge_status === 1) {
          this.free1 = false;
        } else {
          this.free1 = true;
        }
        if (
          this.servicePackage.additional_medical_service_plan.charge_status ===
          1
        ) {
          this.free2 = false;
        } else {
          this.free2 = true;
        }
        this.YMCustomPrice = this.servicePackage.max_price;
      } else {
        this.inside = "";
        this.outside = "";
        this.zengTime = 3;
        this.QCTime1 = "1";
        this.QCTime2 = "1";
        this.QCDiscount = "88";
        this.servicePackage = this.$public.getMatchingItem(
          this.QCList,
          "groupId",
          this.serviceId
        );
        if(this.servicePackage){
           this.must_use1=this.servicePackage.plan_items[0].inside_body_plan.must_use
        this.must_use2=this.servicePackage.plan_items[0].outside_body_plan.must_use
        }
        let QCPlanItem = {
          _id: "",
          weight_model: {},
          inside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
          outside_body_plan: {
            plan_name: "",
            must_use: 1,
            next_plan_days: 1,
            plan_detail_items: [],
          },
        };
        for (let i = 0; i < this.servicePackage.plan_items.length; i++) {
          let item = this.servicePackage.plan_items[i];
          if (
            item.weight_model.min_weight <= Number(this.newestWeight) &&
            Number(this.newestWeight) <= item.weight_model.max_weight
          ) {
            QCPlanItem = item;
          }
        }
        this.QCPlanItem = QCPlanItem;
      }
    },
    // 疫苗
    changeVaccine_plan() {
      this.YMPreview();
    },
    changeRabies_vaccine_plan() {
      this.YMPreview();
    },
    changeAdditional_enhance_needle() {
      this.YMPreview();
    },
    changeAdditional_medical_service_plan() {
      this.YMPreview();
    },
    changeFree1() {
      this.YMPreview();
    },
    changeFree2() {
      this.YMPreview();
    },
    changeYMCustomPrice() {
      this.YMCustomPrice = this.$public.FInt(this.YMCustomPrice);
      this.detail = { list: [] };
      this.getTotalMoney();
      if (
        this.YMCustomPrice < this.servicePackage.min_price ||
        this.YMCustomPrice > this.servicePackage.max_price
      ) {
        return;
      } else {
        this.YMPreview();
      }
    },
    // 驱虫
    changeInside() {
      this.QCPreview();
    },
    changeOutside() {
      this.QCPreview();
    },
    changeZengTime() {
      this.QCPreview();
    },
    changeQCTime1() {
      if(this.$public.FInt(this.QCTime1)){
      this.QCTime1 = this.$public.FInt(this.QCTime1);
      this.QCPreview();
      }
    },
    changeQCTime2() {
     
      if(this.$public.FInt(this.QCTime2)){
        this.QCTime2 = this.$public.FInt(this.QCTime2);
      this.QCPreview();
      }
      
    },
    changeQCDiscount() {
      this.QCDiscount = this.$public.FInt(this.QCDiscount);
      this.QCPreview();
    },
    submit_drawerRemark(obj) {
      this.drawerRemark_state = false;
      if (obj.type === "success") {
        this.remark = obj.data;
      }
    },
    // 预览
    YMPreview() {
      let vaccinePlan = null,
        rabiesVaccinePlan = null,
        additionalMedicalServicePlan = null,
        additionalEnhanceNeedlePlan = null;
      if (this.vaccine_plan) {
        let goods = this.$public.getMatchingItem(
          this.servicePackage.vaccine_plan.use_items,
          "goods_id",
          this.vaccine_plan
        );
        vaccinePlan = {
          planName: this.servicePackage.vaccine_plan.plan_name,
          planCount: this.servicePackage.vaccine_plan.use_count,
          intervalDays: this.servicePackage.vaccine_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      } else {
        return;
      }
      if (this.rabies_vaccine_plan) {
        let goods = this.$public.getMatchingItem(
          this.servicePackage.rabies_vaccine_plan.use_items,
          "goods_id",
          this.rabies_vaccine_plan
        );
        rabiesVaccinePlan = {
          planName: this.servicePackage.rabies_vaccine_plan.plan_name,
          planCount: this.servicePackage.rabies_vaccine_plan.use_count,
          intervalDays: this.servicePackage.rabies_vaccine_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      }
      // else {
      //   return;
      // }
      if (!this.$public.isNull(this.additional_enhance_needle)) {
        let goodsItem = [];
        for (let i = 0; i < this.additional_enhance_needle.length; i++) {
          let goods = this.$public.getMatchingItem(
            this.servicePackage.additional_enhance_needle.use_items,
            "goods_id",
            this.additional_enhance_needle[i]
          );
          goodsItem.push(this.FPlanItem(goods));
        }
        additionalMedicalServicePlan = {
          planName: this.servicePackage.additional_enhance_needle.plan_name,
          planCount: this.servicePackage.additional_enhance_needle.use_count,
          intervalDays:
            this.servicePackage.additional_enhance_needle.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: goodsItem,
        };
      }
      if (!this.$public.isNull(this.additional_medical_service_plan)) {
        let goodsItem = [];
        for (let i = 0; i < this.additional_medical_service_plan.length; i++) {
          let goods = this.$public.getMatchingItem(
            this.servicePackage.additional_medical_service_plan.use_items,
            "goods_id",
            this.additional_medical_service_plan[i]
          );
          goodsItem.push(this.FPlanItem(goods));
        }
        additionalEnhanceNeedlePlan = {
          planName:
            this.servicePackage.additional_medical_service_plan.plan_name,
          planCount:
            this.servicePackage.additional_medical_service_plan.use_count,
          intervalDays:
            this.servicePackage.additional_medical_service_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: goodsItem,
        };
      }
      let customPrice = 0;
      if (this.buyWay1 === "2") {
        if (this.$public.isNull(this.YMCustomPrice)) {
          customPrice = 0;
        } else {
          customPrice = Number(this.YMCustomPrice);
          if (
            customPrice < this.servicePackage.min_price ||
            customPrice > this.servicePackage.max_price
          ) {
            this.$message({
              message: "自定义价格不是有效值",
              type: "error",
            });
            return;
          }
        }
      } else {
        customPrice = 0;
      }

      let params = {
        groupId: this.servicePackage.groupId,
        customPrice: customPrice,
        vaccinePlan: vaccinePlan,
        rabiesVaccinePlan: rabiesVaccinePlan,
        additionalMedicalServicePlan: additionalEnhanceNeedlePlan,
        additionalEnhanceNeedlePlan: additionalMedicalServicePlan,
      };
      if (this.buyWay1 === "0") {
        if (params.additionalEnhanceNeedlePlan !== null)
          params.additionalEnhanceNeedlePlan.isFree = this.free1;
        if (params.additionalMedicalServicePlan !== null)
          params.additionalMedicalServicePlan.isFree = this.free2;
      } else if (this.buyWay1 === "1") {
        if (params.vaccinePlan !== null)
          params.vaccinePlan.rate = this.$public.cheng(
            this.servicePackage.discount_rate,
            100
          );
        if (params.rabiesVaccinePlan !== null)
          params.rabiesVaccinePlan.rate = this.$public.cheng(
            this.servicePackage.discount_rate,
            100
          );
        if (params.additionalEnhanceNeedlePlan !== null)
          params.additionalEnhanceNeedlePlan.isFree = this.free1;
        if (params.additionalMedicalServicePlan !== null)
          params.additionalMedicalServicePlan.isFree = this.free2;
      } else {
        // if(params.vaccinePlan!==null) params.vaccinePlan.rate = this.YMDiscount?Number(this.YMDiscount):100;
        // if(params.rabiesVaccinePlan!==null) params.rabiesVaccinePlan.rate = this.YMDiscount?Number(this.YMDiscount):100;
        if (params.additionalEnhanceNeedlePlan !== null)
          params.additionalEnhanceNeedlePlan.isFree = this.free1;
        if (params.additionalMedicalServicePlan !== null)
          params.additionalMedicalServicePlan.isFree = this.free2;
      }
      let loading = this.$loading();
      this.$http
        .post("/api/MedicalPackage/Vaccine/Preview", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            this.getTotalMoney();
          }
        });
    },
    QCPreview() {
      let outsidePlan = null,
        insidePlan = null;
      if (this.outside) {
        let goods = this.$public.getMatchingItem(
          this.QCPlanItem.outside_body_plan.plan_detail_items,
          "goods_id",
          this.outside
        );
        outsidePlan = {
          planName: this.QCPlanItem.outside_body_plan.plan_name,
          planCount: 1,
          intervalDays: this.QCPlanItem.outside_body_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      } else {
        return;
      }
      if (this.inside) {
        let goods = this.$public.getMatchingItem(
          this.QCPlanItem.inside_body_plan.plan_detail_items,
          "goods_id",
          this.inside
        );
        insidePlan = {
          planName: this.QCPlanItem.inside_body_plan.plan_name,
          planCount: 1,
          intervalDays: this.QCPlanItem.inside_body_plan.next_plan_days,
          isFree: false,
          rate: 100,
          goodsItem: [this.FPlanItem(goods)],
        };
      }
      let params = {
        groupId: this.servicePackage.groupId,
        outsidePlan: outsidePlan,
        insidePlan: insidePlan,
      };
      if (this.buyWay2 === "0") {
        let zeng = this.$public.getMatchingItem(
          this.servicePackage.buy_options,
          "times",
          this.zengTime
        );
        if (params.insidePlan !== null) {
          params.insidePlan.planCount = zeng.give_times;
          params.insidePlan.isFree = true;
        }
        if (params.outsidePlan !== null) {
          params.outsidePlan.planCount = zeng.times;
          params.outsidePlan.isFree = false;
        }
      } else if (this.buyWay2 === "1") {
        if (params.insidePlan !== null) {
          params.insidePlan.planCount = this.QCTime1;
          params.insidePlan.rate = this.FRate(
            this.QCTime1,
            this.servicePackage.buy_options
          );
        }
        if (params.outsidePlan !== null) {
          params.outsidePlan.planCount = this.QCTime2;
          params.outsidePlan.rate = this.FRate(
            this.QCTime2,
            this.servicePackage.buy_options
          );
        }
      } else {
        if (params.insidePlan !== null) {
          params.insidePlan.planCount = this.QCTime1;
          params.insidePlan.rate = Number(this.QCDiscount);
        }
        if (params.outsidePlan !== null) {
          params.outsidePlan.planCount = this.QCTime2;
          params.outsidePlan.rate = Number(this.QCDiscount);
        }
      }
      let loading = this.$loading();
      this.$http
        .post("/api/MedicalPackage/Deworming/Preview", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            this.getTotalMoney();
          }
        });
    },
    getTotalMoney() {
      let totalMoney = 0;
      for (let i = 0; i < this.detail.list.length; i++) {
        totalMoney = this.$public.jia(
          totalMoney,
          this.detail.list[i].planMoney
        );
      }
      this.totalMoney = totalMoney;
    },
    FPlanItem(obj) {
      if (obj.goods_type === 1) {
        let a = {
          goodsId: obj.goods_id,
          goodsName: obj.goods_name,
          goodsType: obj.goods_type,
          brand: obj.brand_name,
          categoryId: obj.model.category_info._id,
          categoryName: obj.model.category_info.name,
          skus: "",
          skuValue: obj.model.old_packinfo_info.sku_value,
          unitId: "",
          unit: obj.model.old_packinfo_info.in_unit,
          outUnit: obj.model.old_packinfo_info.unit,
          originalPrice: this.$public.getCFPrice(
            obj.model.medical_ext_info.allow_wholesale,
            obj.model.old_packinfo_info.in_exchanage,
            obj.model.pprice
          ),
          price: this.$public.getCFPrice(
            obj.model.medical_ext_info.allow_wholesale,
            obj.model.old_packinfo_info.in_exchanage,
            obj.model.pprice
          ),
          num: obj.use_num,
          activityId: "",
          activityName: "",
          totalMoney: 0,
          goodsUsage: "",
          goodsDosage: obj.out_num,
          goodsTimes: "",
          remark: "",
          canActivity: false,
          allowWholesale: obj.model.medical_ext_info.allow_wholesale,
          dosageCeiling: obj.model.medical_ext_info.dosage_ceiling,
          dosageCeilingValue: obj.model.medical_ext_info.dosage_ceiling_value,
          countPriceDosage: 0,
          isNeedCode: obj.use_consumableMaterial_status, // 是否有耗材
        };
        return a;
      } else {
        let skuItem = {};
        for (let i = 0; i < obj.model.serviceItems.length; i++) {
          let sku = obj.model.serviceItems[i];
          if (obj.sku_id === sku.service_objectId) {
            skuItem = sku;
          }
        }
        let a = {
          goodsId: obj.goods_id,
          goodsName: obj.goods_name,
          goodsType: obj.goods_type,
          brand: obj.brand_name,
          categoryId: obj.model.category_info._id,
          categoryName: obj.model.category_info.name,
          skus: skuItem.service_objectId,
          skuValue: skuItem.extend_attr + " " + skuItem.service_objectName,
          unitId: "",
          unit: skuItem.frequency_text,
          outUnit: "",
          originalPrice: skuItem.price,
          price: skuItem.price,
          num: obj.use_num,
          activityId: "",
          activityName: "",
          totalMoney: 0,
          goodsUsage: "",
          goodsDosage: 0,
          goodsTimes: "",
          remark: "",
          canActivity: false,
          allowWholesale: 1,
          dosageCeiling: 0,
          dosageCeilingValue: 0,
          countPriceDosage: 0,
          isNeedCode: obj.use_consumableMaterial_status, // 是否有耗材
        };
        return a;
      }
    },
    FRate(t, obj) {
      t = Number(t);
      let index = -1;
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].times > t) {
          index = i;
          break;
        }
      }
      if (index === 0) {
        return 100;
      } else if (index === -1) {
        return this.$public.cheng(obj[obj.length - 1].discount_rate, 100);
      } else {
        return this.$public.cheng(obj[index - 1].discount_rate, 100);
      }
    },
    // 销售人员
    changeSaleManIdList() {
      console.log(this.saleManIdList);
    },
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
        }
      });
    },
    // 获取列表
    getYMList() {
      if (this.$public.isNull(this.curPetInfo._id)) {
        return;
      }
      let params = {
        keyword: "",
        applytype: "0," + this.curPetInfo.apply_type.value,
        categoryId: "",
        buyWay: this.buyWay1,
        pageIndex: 1,
        pageSize: 100,
      };
      let loading = this.$loading();
      this.$http.post("/api/Product/Vaccine/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.YMList = res.data.data;
          if (this.$public.isNull(this.YMList)) {
            this.serviceId = "";
            this.servicePackage = {
              vaccine_plan: {},
              rabies_vaccine_plan: {},
              additional_enhance_needle: {},
              additional_medical_service_plan: {},
              discount_rate: 0,
              buy_options: [],
              plan_items: [],
              min_price: 0,
              max_price: 0,
            };
          } else {
            this.serviceId = this.YMList[0].groupId;
            this.servicePackage = this.YMList[0];
          }
          this.detail = { list: [] };
          this.getTotalMoney();
          this.changeServiceId();
        }
      });
    },
    getQCList() {
      let hsPetMaster=0
      if(this.userInfo.pet_count&&this.userInfo.pet_count.hsTotal>0){
        hsPetMaster=1
    }else if(this.userInfo.pet_count&&this.userInfo.pet_count.hsTotal==0){
      hsPetMaster=2
    }
      if (this.$public.isNull(this.curPetInfo._id)) {
        return;
      }
      let params = {
        keyword: "",
        applytype: "0," + this.curPetInfo.apply_type.value,
        categoryId: "",
        buyWay: this.buyWay2,
        pageIndex: 1,
        pageSize: 100,
        hsPetMaster:hsPetMaster,
        grade:this.userInfo.club_card. surplus_day
      };
      let loading = this.$loading();
      this.$http.post("/api/Product/Deworming/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.QCList = res.data.data;
          if (this.$public.isNull(this.QCList)) {
            this.serviceId = "";
            this.servicePackage = {
              vaccine_plan: {},
              rabies_vaccine_plan: {},
              additional_enhance_needle: {},
              additional_medical_service_plan: {},
              discount_rate: 0,
              buy_options: [],
              plan_items: [],
              min_price: 0,
              max_price: 0,
            };
            this.QCPlanItem = {
              _id: "",
              weight_model: {},
              inside_body_plan: {
                plan_name: "",
                must_use: 1,
                next_plan_days: 1,
                plan_detail_items: [],
              },
              outside_body_plan: {
                plan_name: "",
                must_use: 1,
                next_plan_days: 1,
                plan_detail_items: [],
              },
            };
          } else {
            this.serviceId = this.QCList[0].groupId;
            this.servicePackage = this.QCList[0];
            for (let i = 0; i < this.servicePackage.plan_items.length; i++) {
              let item = this.servicePackage.plan_items[i];
              if (
                item.weight_model.min_weight <= Number(this.newestWeight) &&
                Number(this.newestWeight) <= item.weight_model.max_weight
              ) {
                this.QCPlanItem = item;
              }
            }
          }
          this.detail = { list: [] };
          this.getTotalMoney();
          this.changeServiceId();
        }
      });
    },
    getGroupTypeList() {
      this.$http
        .get(
          process.env.VUE_APP_Url2 +
            "api/product/group/Vaccine/buyway/available"
        )
        .then((res) => {
          if (res.code == 0) {
            this.YMGroupTypeList = res.data;
            this.buyWay1 = this.YMGroupTypeList[0].value;
            // 获取完满减，折扣，自定义后，再请求套餐列表
            this.changeNewestWeight();
          }
        });
      this.$http
        .get(
          process.env.VUE_APP_Url2 +
            "api/product/group/Deworming/buyway/available"
        )
        .then((res) => {
          if (res.code == 0) {
            this.QCGroupTypeList = res.data;
            this.buyWay2 = this.QCGroupTypeList[0].value;
          }
        });
    },
    // 创建订单
    submitOrder() {
      if (this.$public.isNull(this.userInfo._id)) {
        this.$message({
          message: "请选择顾客",
          type: "error",
        });
        return;
      }
      if (this.$public.isNull(this.curPetInfo._id)) {
        this.$message({
          message: "请选择宠物",
          type: "error",
        });
        return;
      }
      if (this.$public.isNull(this.saleManIdList)) {
        this.$message({
          message: "请选择销售人员",
          type: "error",
        });
        return;
      }
      let salesMans = [];
      for (let i = 0; i < this.saleManIdList.length; i++) {
        let arr = this.saleManIdList[i].split(",");
        salesMans.push({ userId: arr[0], userName: arr[1] });
      }
      if (this.detail.list.length === 0) {
        this.$message({
          message: "记录生成失败！！请查看药品、价格是否正确",
          type: "error",
        });
        return;
      }

      let params = {
        memberId: this.userInfo._id,
        memberName: this.userInfo.basic_info.nick_name,
        memberMobile: this.userInfo.basic_info.user_mobile,
        petId: this.curPetInfo._id,
        petName: this.curPetInfo.nick_name,
        petType: this.curPetInfo.apply_type.title,
        typeName: this.curPetInfo.category_info.name, // Desc:宠物种类 Nullable:False
        sex: this.curPetInfo.pet_sex,
        birthDay: this.curPetInfo.bron_date,
        weight: this.newestWeight,
        serviceTypeId: this.type === "QC" ? 2 : 1, // 1疫苗；2驱虫
        payType: 1, // 1全额支付；2计划支付;
        discountRate: 0, // 优惠折扣率 默认为0
        remark: this.remark,
        planList: this.detail.list,
        salesMans: salesMans,
        servicePackageName: this.servicePackage.title,
        servicePackageId: this.servicePackage.groupId,
      };
      let loading = this.$loading();
      this.$http.post("/api/MedicalPackage/Insert", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.YMQCDetail = res.data;
          console.log(res.data);
          if (this.direct) {
            this.curOrder = res.data.data;
            this.orderId = this.curOrder._id;
            this.yiliao_state = true;
            // this.$http
            //   .get("/api/Pay/GotoPay", { orderNum: this.curOrder.no })
            //   .then((res1) => {
            //     // this.$http.get('/api/Pay/ScanPayOrder', {orderNum:this.curOrder.no}).then(res1 => {
            //     if (res1.code == 0) {
            //       this.codeUrl = res1.data.codeUrl;
            //       // this.dialogPay_state = true
            //     }
            //   });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            // this.$router.push({path:"/yiliao/ymqcEdit",query:{id:this.YMQCDetail.serviceId}})
            this.$store.commit("yiliaoxin/remove_router");
            if (this.$store.state.yiliaoxin.router.length === 0) {
              this.ymqcParams.type = "list";
              this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
              this.$store.commit("yiliaoxin/set_curBusiness", "疫苗驱虫");
            }
          }
        }
      });
    },
    submit_dialog_pay() {
      this.dialogPay_state = false;
      // this.$router.push({path:"/yiliao/ymqcEdit",query:{id:this.YMQCDetail.serviceId}})
      this.$store.commit("yiliaoxin/remove_router");
      if (this.$store.state.yiliaoxin.router.length === 0) {
        this.ymqcParams.type = "list";
        this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
        this.$store.commit("yiliaoxin/set_curBusiness", "疫苗驱虫");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  padding-bottom: 68px;
  box-sizing: border-box;
  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;
    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;
      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }
      .titleR {
        width: 50%;
        text-align: right;
        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
    .content {
      display: flex;
      .L {
        width: 500px;
        border-right: 1px solid #f5f5f5;
        flex-shrink: 0;
        overflow: auto;
        padding-top: 40px;
        &::-webkit-scrollbar {
          width: 4px;
          // height: 4px;
        }
        .item {
          display: flex;
          padding-bottom: 20px;
          .label {
            font-size: 14px;
            width: 140px;
            text-align: right;
            line-height: 32px;
            padding-right: 10px;
            box-sizing: border-box;
          }
          .value {
            width: 360px;
            .xmjBox {
              display: flex;
              justify-content: flex-start;
              padding: 10px 20px 10px;
              flex-wrap: wrap;
              .xmjItem {
                position: relative;
                width: 120px;
                box-sizing: border-box;
                line-height: 38px;
                text-align: center;
                border: 1px solid #dcdfe6;
                font-size: 14px;
                cursor: pointer;
                margin-bottom: 10px;
                margin-right: 15px;
                &.active {
                  background-color: #e3f2ff;
                  border-color: #1890ff;
                }
                .checked {
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  width: 26px;
                  height: 13px;
                  text-align: center;
                  color: #fff;
                }
              }
            }
          }
          ::v-deep .el-select__tags-text {
            display: inline-block;
            max-width: 148px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          ::v-deep .el-tag__close.el-icon-close {
            top: -7px;
          }
        }
      }
      .R {
        width: 100%;
        height: 100%;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 4px;
          // height: 4px;
        }
        .col {
          display: flex;
          align-items: center;
          padding-bottom: 15px;
          .RLabel {
            font-size: 14px;
            color: #6e6e6e;
            text-align: right;
            line-height: 28px;
          }
        }
        .roomBox {
          display: flex;
          padding: 10px 70px 10px 100px;
          flex-wrap: wrap;
          .room {
            position: relative;
            width: 210px;
            height: 110px;
            border: 1px solid #ccc;
            box-sizing: border-box;
            background-color: #e8e8e8;
            margin: 10px 20px;
            text-align: center;
            cursor: pointer;
            .mask {
              position: absolute;
              top: -2px;
              left: -2px;
              z-index: 10;
              width: 210px;
              height: 110px;
              background-color: rgba(0, 0, 0, 0.5);
            }
            .tip {
              position: absolute;
              top: -2px;
              left: -2px;
              width: 55px;
              height: 20px;
              text-align: center;
              color: #fff;
              background-color: #ffae11;
              font-size: 12px;
              line-height: 20px;
            }
            .checked {
              position: absolute;
              right: -2px;
              bottom: -2px;
              width: 40px;
              height: 18px;
              text-align: center;
              color: #fff;
            }
            .roomName {
              font-size: 16px;
              color: #262626;
              padding-top: 25px;
              font-weight: bold;
            }
            .roomPrice {
              font-size: 14px;
              color: #262626;
              padding-top: 10px;
            }
            &.active {
              background-color: #ffeac2;
              border-color: #ffae11;
            }
          }
        }
      }
    }
  }
  .settlement {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    padding: 12px 20px;
    box-sizing: border-box;
    .settlementL {
      width: 40%;
      font-size: 14px;
      line-height: 32px;
    }
    .settlementR {
      width: 60%;
      text-align: right;
      font-size: 14px;
      line-height: 32px;
      .text {
        color: $fontColor;
        font-size: 14px;
        padding: 0px 24px 0;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
